import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@material-ui/core';

import { t } from '~/helpers';
import { recordFiltering } from '~/store/modules/operacaoliberacaoremota/actions';

import { Form } from '..';

export default function Heading() {
  const { profile } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [modal, setModal] = React.useState(false);
  const inserirLibRemotaRef = React.useRef(null);
  const { params } = useSelector((state) => state.operacaoliberacaoremota);  //

  // open Modal Tabs
  const handleOpenIncluirLibRemota = React.useCallback(() => {
    setModal(true);
  }, []);

  // close Modal Tabs
  const handleCloseModal = React.useCallback(() => {
    setModal(false);
    dispatch(recordFiltering(params));
  }, [params]);

  React.useEffect(() => {
    if (modal) inserirLibRemotaRef.current.openModal();
  }, [modal]);

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleOpenIncluirLibRemota} size="small">
        {t('s.geral.botaoincluir')}
      </Button>
      {modal && <Form ref={inserirLibRemotaRef} onCloseModal={handleCloseModal} />}
    </>
  );
};

